<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  show: { type: Boolean, default: false },
  variant: { type: String, default: 'success' },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  actionLabel: { type: String, default: '' },
});

defineEmits(['close', 'action']);

const { t } = useI18n();

const tone = computed(() => {
  if (props.variant === 'danger') {
    return {
      wrapper: 'border-[#f3c7cd] bg-[#fff6f7]',
      icon: 'i-lucide-triangle-alert text-[#b42318]',
      title: 'text-[#7a271a]',
      body: 'text-[#9a3412]',
      action: 'border-[#f0d4d4] text-[#b42318] hover:bg-[#fff0f1]',
    };
  }

  return {
    wrapper: 'border-[#cce7d5] bg-[#f3fbf6]',
    icon: 'i-lucide-badge-check text-[#0f7a38]',
    title: 'text-[#14532d]',
    body: 'text-[#166534]',
    action: 'border-[#cce7d5] text-[#166534] hover:bg-[#ebf8ef]',
  };
});
</script>

<template>
  <div
    v-show="show"
    class="flex flex-wrap items-start gap-3 rounded-lais border px-4 py-3"
    :class="tone.wrapper"
  >
    <span
      class="mt-0.5 size-5 shrink-0"
      :class="tone.icon"
      aria-hidden="true"
    />

    <div class="min-w-0 flex-1">
      <p v-if="title" class="text-[13px] font-semibold" :class="tone.title">
        {{ title }}
      </p>
      <p v-if="message" class="mt-1 text-[12px] leading-5" :class="tone.body">
        {{ message }}
      </p>
    </div>

    <div class="flex items-center gap-2">
      <button
        v-if="actionLabel"
        type="button"
        class="rounded-lais border px-3 py-2 text-[12px] font-semibold transition-all"
        :class="tone.action"
        @click="$emit('action')"
      >
        {{ actionLabel }}
      </button>
      <button
        type="button"
        class="rounded-lais border border-transparent px-2 py-2 text-[12px] font-semibold text-lais-text-muted transition-all hover:text-lais-text"
        @click="$emit('close')"
      >
        {{ t('LEAD_ALERTS.TOAST.CLOSE') }}
      </button>
    </div>
  </div>
</template>
